'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { Either } from '@sola/schema/dotcom/helpers.ts';
import { InputField, InputFieldProps, InputFieldWithAriaLabel, InputFieldWithLabel, InputFieldWithoutLabel } from '../input-field/input-field.tsx';
export type EmailFieldProps = Either<InputFieldWithLabel, Either<InputFieldWithAriaLabel, InputFieldWithoutLabel>> & Omit<InputFieldProps, 'type' | 'inputMode' | 'step' | 'pattern' | 'spellCheck' | 'autoCorrect'>;
export const EmailField: React.FC<EmailFieldProps> = t0 => {
  const $ = _c(11);
  let fieldProps;
  if ($[0] !== t0) {
    ({
      ...fieldProps
    } = t0);
    $[0] = t0;
    $[1] = fieldProps;
  } else {
    fieldProps = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["forms"];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /^$|^[\w!#$%&'*+/=?^_`{|}~.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]{2,63})$/;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("forms:errors.invalidEmail");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = {
      value: t2,
      message: t3
    };
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fieldProps || $[9] !== t4) {
    t5 = <InputField type="email" autoComplete="email" autoCapitalize="off" pattern={t4} {...fieldProps} />;
    $[8] = fieldProps;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};